<header class="bg-white shadow-sm px-4 md:px-8 py-3 flex justify-between items-center sticky top-0 z-20">
  <!-- Logo & Navigation -->
  <div class="flex items-center gap-4">
    <button
      type="button"
      class="flex items-center cursor-pointer flex-shrink-0"
      [routerLink]="homePath"
      aria-label="Voltar para Dashboard"
    >
      <img src="/logo.svg" alt="amIA" class="h-10 w-auto" />
    </button>

    <nav class="flex items-center gap-1">
      @if (isLoggedIn() && canManageAms()) {
        <app-nav-link [path]="clientsPath" label="Clientes" icon="fa-building" ariaLabel="Área de Clientes" />
      }
      @if (isLoggedIn()) {
        <app-nav-link
          [path]="homePath"
          label="Projetos"
          icon="fa-th-large"
          [exact]="true"
          ariaLabel="Área de Projetos"
        />
      }
      @if (isLoggedIn() && canAccessAms()) {
        <app-nav-link [path]="amsPath" label="Sustentação" icon="fa-headset" ariaLabel="Área de Sustentação" />
      }
      @if (isLoggedIn() && isTeamTrackingManager()) {
        <app-nav-link
          [path]="teamTrackingPath"
          label="Acompanhamento de Equipe"
          icon="fa-users"
          ariaLabel="Acompanhamento de Equipe"
        />
      }
    </nav>
  </div>

  <!-- Actions & User -->
  <div class="flex items-center gap-2">
    @if (isLoggedIn() && isPlatformAdmin()) {
      <a
        [routerLink]="settingsPath"
        routerLinkActive
        #rlaSettings="routerLinkActive"
        class="hidden md:flex w-9 h-9 rounded-lg items-center justify-center transition-colors"
        [class.text-amcom-purple]="rlaSettings.isActive"
        [class.bg-purple-50]="rlaSettings.isActive"
        [class.text-slate-500]="!rlaSettings.isActive"
        [class.hover:bg-slate-100]="!rlaSettings.isActive"
        [class.hover:text-slate-700]="!rlaSettings.isActive"
        aria-label="Configurações da plataforma"
        title="Configurações"
      >
        <i class="fas fa-gear"></i>
      </a>
    }
    @if (isLoggedIn()) {
      <app-user-profile [userName]="userName()" [avatarUrl]="userPhotoUrl()" (logout)="logout()" />
    }
    @if (isLoggedIn()) {
      <button
        type="button"
        class="md:hidden p-2 rounded-lg hover:bg-slate-100 text-slate-600 hover:text-slate-800 transition-colors"
        (click)="toggleMenu()"
        [attr.aria-expanded]="menuOpen()"
        [attr.aria-label]="menuOpen() ? 'Fechar menu' : 'Abrir menu'"
      >
        <i class="fas text-lg" [class.fa-bars]="!menuOpen()" [class.fa-times]="menuOpen()"></i>
      </button>
    }
  </div>
</header>

@if (isLoggedIn() && menuOpen()) {
  <nav
    class="fixed top-[var(--app-header-height)] left-0 w-full bg-white shadow-md z-10 md:hidden"
    aria-label="Menu mobile"
  >
    <div class="flex flex-col p-3 gap-1">
      @if (canManageAms()) {
        <app-nav-link
          [path]="clientsPath"
          label="Clientes"
          icon="fa-building"
          [mobile]="true"
          ariaLabel="Área de Clientes"
          (activated)="closeMenu()"
        />
      }
      @if (canAccessAms()) {
        <app-nav-link
          [path]="amsPath"
          label="Sustentação"
          icon="fa-headset"
          [mobile]="true"
          ariaLabel="Área de Sustentação"
          (activated)="closeMenu()"
        />
      }
      @if (isTeamTrackingManager()) {
        <app-nav-link
          [path]="teamTrackingPath"
          label="Acompanhamento de Equipe"
          icon="fa-users"
          [mobile]="true"
          ariaLabel="Acompanhamento de Equipe"
          (activated)="closeMenu()"
        />
      }
      <app-nav-link
        [path]="homePath"
        label="Projetos"
        icon="fa-th-large"
        [exact]="true"
        [mobile]="true"
        ariaLabel="Área de Projetos"
        (activated)="closeMenu()"
      />
      @if (isPlatformAdmin()) {
        <app-nav-link
          [path]="settingsPath"
          label="Configurações"
          icon="fa-gear"
          [mobile]="true"
          ariaLabel="Configurações da plataforma"
          (activated)="closeMenu()"
        />
      }
    </div>
  </nav>
}
